(() => {
  const menu = document.querySelector('[data-mobile-menu]');
  const menuBtn = document.querySelector('[data-menu-toggle]');
  const search = document.querySelector('[data-search-panel]');
  const searchBtn = document.querySelector('[data-search-toggle]');
  const close = (el,btn) => {el?.classList.remove('open'); btn?.setAttribute('aria-expanded','false');};
  menuBtn?.addEventListener('click',()=>{const opened=menu.classList.toggle('open');menuBtn.setAttribute('aria-expanded',String(opened));close(search,searchBtn)});
  searchBtn?.addEventListener('click',()=>{const opened=search.classList.toggle('open');searchBtn.setAttribute('aria-expanded',String(opened));close(menu,menuBtn);if(opened)search.querySelector('input')?.focus()});
  document.querySelectorAll('[data-variant-select]').forEach(select=>{
    select.addEventListener('change',()=>{
      const option=select.selectedOptions[0];
      const price=document.querySelector('[data-variant-price]');
      if(price && option.dataset.price)price.textContent=option.dataset.price;
      const button=document.querySelector('[data-add-to-cart]');
      if(button){button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?'Sold out':'Add to bag ↗';}
      const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
    });
  });

  const updateQuickAdd = dialog => {
    const data = dialog.querySelector('[data-quick-add-variants]');
    if(!data)return;
    let variants=[];
    try{variants=JSON.parse(data.textContent)}catch{return;}
    const groups=[...dialog.querySelectorAll('[data-quick-option-group]')];
    const selectedOptions=()=>{
      const selected=new Map();
      groups.forEach(group=>{
        const checked=group.querySelector('[data-quick-option]:checked');
        if(checked)selected.set(Number(group.dataset.optionIndex),checked.value);
      });
      return selected;
    };
    let selected=selectedOptions();
    groups.forEach(group=>{
      const optionIndex=Number(group.dataset.optionIndex);
      group.querySelectorAll('[data-quick-option]').forEach(input=>{
        const compatible=variants.some(variant=>variant.options[optionIndex]===input.value&&variant.options.every((value,index)=>index===optionIndex||!selected.has(index)||selected.get(index)===value));
        input.disabled=!compatible;
        input.closest('label')?.classList.toggle('is-unavailable',!compatible);
        if(input.checked&&!compatible)input.checked=false;
      });
    });
    selected=selectedOptions();
    const allSelected=groups.every(group=>selected.has(Number(group.dataset.optionIndex)));
    const variant=allSelected?variants.find(item=>item.options.every((value,index)=>selected.get(index)===value)):null;
    const variantInput=dialog.querySelector('[data-quick-variant-id]');
    const submit=dialog.querySelector('[data-quick-add-submit]');
    const status=dialog.querySelector('[data-quick-add-status]');
    if(variantInput)variantInput.value=variant?variant.id:'';
    if(submit)submit.disabled=!variant;
    if(status)status.textContent=variant?'Ready to add this item to your bag.':'Choose the available options to continue.';
  };

  document.addEventListener('click',event=>{
    const opener=event.target.closest('[data-quick-add-open]');
    if(opener){
      const dialog=document.getElementById(opener.dataset.quickAddOpen);
      if(dialog){
        updateQuickAdd(dialog);
        dialog.showModal();
        dialog.querySelector('[data-quick-option]:not(:disabled):not(:checked)')?.focus()||dialog.querySelector('[data-quick-option]:checked')?.focus();
      }
      return;
    }
    const closer=event.target.closest('[data-quick-add-close]');
    if(closer){closer.closest('[data-quick-add-dialog]')?.close();return;}
    if(event.target.matches('[data-quick-add-dialog]'))event.target.close();
  });
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-quick-option]'))updateQuickAdd(event.target.closest('[data-quick-add-dialog]'));
  });
})();
